import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { QuoteLineType } from "@/common/types";

const getQuoteLineById = async (id: string | number) => {
  return axiosInstance
    .get(`quotes/lines/${id}`)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetQuoteLineById = (id: string | number | undefined) => {
  return useQuery<QuoteLineType>({
    queryKey: ["quotes", id],
    queryFn: () => getQuoteLineById(id as string | number),
    enabled: !!id,
  });
};
export default useGetQuoteLineById;
